/** Die Fenster und Seitenleisten: Konto, Verwaltung, Freigabe, Vorlagen, Design. */
export const dialogs = {
    // --- Eigenes Konto ---------------------------------------------------------
    'account.title': 'Mein Konto',
    'account.operator': 'Betreiber',
    'account.changePassword': 'Passwort ändern',
    'account.currentPassword': 'Bisheriges Passwort',
    'account.newPassword': 'Neues Passwort',
    'account.repeat': 'Noch einmal',
    'account.minLength': 'Mindestens 10 Zeichen.',
    'account.mismatch': 'Die beiden neuen Passwörter stimmen nicht überein.',
    'account.changeFailed': 'Ändern fehlgeschlagen.',
    'account.changed': 'Passwort geändert.',
    'account.signOutHint': 'Mit dem Wechsel werden alle angemeldeten Geräte abgemeldet. Dieses hier bleibt drin.',
    'account.languageHint': 'Gilt auf jedem Gerät, an dem du dich anmeldest.',
    // --- Betreiberansicht ------------------------------------------------------
    'admin.loadFailed': 'Übersicht konnte nicht geladen werden.',
    'admin.changeFailed': 'Änderung fehlgeschlagen.',
    'admin.createFailed': 'Anlegen fehlgeschlagen.',
    'admin.deleteFailed': 'Löschen fehlgeschlagen.',
    'admin.deletePrompt': 'Alles von „{org}" wird gelöscht: {boards}, {storage} Medien, {members} Konten.\n\nDas lässt sich nicht rückgängig machen — nur über die nächtliche Sicherung.\n\nZum Bestätigen den Namen eintippen:',
    'admin.deleted': '„{org}" wurde gelöscht.',
    'admin.board.one': '{count} Board',
    'admin.board.many': '{count} Boards',
    'admin.daysLeft': 'noch {days} T',
    'admin.daysSince': 'seit {days} T',
    'admin.noAdmins': 'noch niemand in der Verwaltung',
    'admin.people': 'Personen',
    'admin.priceTitle': 'Listenpreis dieses Pakets. Abgerechnet wird von Hand.',
    'admin.onRequest': 'auf Anfrage',
    'admin.until': 'Läuft bis',
    'admin.untilTitle': 'Leer lassen = unbefristet',
    'admin.untilHint': 'Leer lassen für unbefristet.',
    'admin.extend': '+1 Jahr',
    'admin.extendTitle': 'Laufzeit um ein Jahr verlängern',
    'admin.addCustomer': 'Kunde aufnehmen',
    'admin.orgPlaceholder': 'Musterfirma GmbH',
    // --- Organisation ----------------------------------------------------------
    'team.orgName': 'Name der Organisation',
    'team.addPerson': 'Person aufnehmen',
    'team.add': 'Aufnehmen',
    'team.role': 'Rolle',
    'team.addFailed': 'Hinzufügen fehlgeschlagen.',
    'team.roleFailed': 'Rolle konnte nicht geändert werden.',
    'team.removeFailed': 'Entfernen fehlgeschlagen.',
    'team.pendingTitle': 'Eingeladen, hat den Link noch nicht geöffnet',
    'team.withdrawInvite': 'Einladung zurückziehen',
    'team.removeFromOrg': 'Aus der Organisation entfernen',
    'team.mailPlaceholder': 'name@firma.de',
    'team.addHint': 'Sie bekommt eine Einladung und setzt ihr Passwort selbst. Gibt es zu der Adresse schon ein Konto, ist sie sofort dabei.',
    'team.invited': 'Einladung an {email} verschickt. Sie setzt sich selbst ein Passwort.',
    'team.alreadyExisted': '{name} ist dabei — das Konto gab es bereits.',
    'team.removed': '{name} entfernt.',
    'team.removedWithBoards': '{name} entfernt. {boards} sind an dich übergegangen.',
    'team.board.one': '{count} Board',
    'team.board.many': '{count} Boards',
    'team.inviteMailFailed': 'Die Einladungsmail ging nicht raus. Bitte diesen Link selbst weitergeben:',
    // --- Freigabe --------------------------------------------------------------
    'share.tabTeam': 'Im Team',
    'share.tabGuests': 'Für Gäste',
    'share.teamLead': 'Ein Board ist zunächst privat. Wer daran mitarbeiten soll, bekommt es hier — mit vollem Bearbeitungsrecht.',
    'share.accessLoadFailed': 'Zugriffsrechte konnten nicht geladen werden.',
    'share.changeFailed': 'Änderung fehlgeschlagen.',
    'share.visibility': 'Sichtbarkeit',
    'share.privateHint': 'Nur der Eigentümer und ausdrücklich hinzugefügte Personen.',
    'share.orgHint': 'Jedes Mitglied der Organisation findet das Board in seiner Übersicht.',
    'share.owner': 'Eigentümer',
    'share.withdraw': 'Zugriff zurücknehmen',
    'share.withdrawFor': 'Zugriff für {name} zurücknehmen',
    'share.addPerson': 'Person hinzufügen',
    'share.choosePerson': 'Aus der Organisation wählen …',
    'share.orgOpenHint': 'Solange das Board der Organisation offensteht, wirkt diese Liste nur als Merkposten — sehen können es ohnehin alle.',
    'share.ownerOnly': 'Ändern kann den Zugriff der Eigentümer oder die Verwaltung.',
    'share.guestLead': 'Wer den Link hat, sieht das Board — ohne Anmeldung und ausschließlich lesend. Wie viel er dabei selbst steuern darf, legt der Modus fest.',
    'share.mode': 'Freigabe-Modus',
    'share.greeting': 'Begrüßung auf dem Wartebildschirm',
    'share.optional': '(freiwillig)',
    'share.greetingPlaceholder': 'Kickoff Müller GmbH — wir beginnen um 14 Uhr.',
    'share.noWaitingHint': 'In der freien Ansicht gibt es keinen Wartebildschirm — der Gast sieht das Board sofort. Die Begrüßung bliebe ungelesen.',
    'share.createLink': 'Link erzeugen',
    'share.creating': 'Wird erzeugt …',
    'share.previewWaiting': 'Wartebildschirm ansehen',
    'share.closePreview': 'Vorschau schließen',
    'share.noLinks': 'Noch kein Link vergeben.',
    'share.revoke': 'Zurückziehen',
    // --- Frame-Vorlagen --------------------------------------------------------
    'templates.applyTitle': 'Vorlage einsetzen',
    'templates.saveTitle': 'Als Vorlage sichern',
    'templates.loadFailed': 'Vorlagen konnten nicht geladen werden.',
    'templates.applyFailed': 'Vorlage konnte nicht eingesetzt werden.',
    'templates.saveFailed': 'Vorlage konnte nicht gesichert werden.',
    'templates.delete': 'Vorlage löschen',
    'templates.deleteLabel': 'Vorlage {name} löschen',
    'templates.elements.one': '{count} Element',
    'templates.elements.many': '{count} Elemente',
    'templates.saveCount.one': '{count} Element wird mitgesichert.',
    'templates.saveCount.many': '{count} Elemente werden mitgesichert.',
    'templates.copying': 'Vorlage wird kopiert …',
    'templates.scope': 'Reichweite',
    'templates.save': 'Vorlage sichern',
    'templates.saving': 'Wird gesichert …',
    // --- Boardvorlagen ---------------------------------------------------------
    'boardTemplates.applyTitle': 'Boardvorlage einsetzen',
    'boardTemplates.applyLead': 'Ein Gerüst legt leere Frames an — Anordnung und Reihenfolge, keinen Inhalt. Auf einem Board, das schon Frames hat, kommt es rechts daneben und hinten in die Vortragsreihenfolge.',
    'boardTemplates.loadFailed': 'Boardvorlagen konnten nicht geladen werden.',
    'boardTemplates.applyFailed': 'Gerüst konnte nicht eingesetzt werden.',
    'boardTemplates.applying': 'Gerüst wird eingesetzt …',
    'boardTemplates.saveFailed': 'Gerüst konnte nicht gesichert werden.',
    'boardTemplates.delete': 'Boardvorlage löschen',
    'boardTemplates.deleteLabel': 'Boardvorlage {name} löschen',
    'boardTemplates.frame.one': '{count} Frame',
    'boardTemplates.frame.many': '{count} Frames',
    'boardTemplates.noFrames': 'Dieses Board hat noch keine Frames.',
    'boardTemplates.fromBoard': 'Aus diesem Board',
    'boardTemplates.fromBoardTitle': 'Die Frames dieses Boards als Gerüst sichern — ohne ihren Inhalt',
    'boardTemplates.compose': 'Neu zusammenstellen',
    'boardTemplates.saveTitle': 'Als Boardvorlage sichern',
    'boardTemplates.saveLead': 'Gesichert wird das Gerüst: Lage, Größe und Reihenfolge der Frames. Was in ihnen liegt — Bilder, Texte, Websites — bleibt draußen.',
    'boardTemplates.namePlaceholder': 'z. B. Kundentermin',
    'boardTemplates.included': 'Was mitkommt',
    'boardTemplates.withNames': 'Namen der Frames',
    'boardTemplates.withNamesHint': ' — sonst „Frame 1", „Frame 2" …',
    'boardTemplates.withStyle': 'Gestaltung',
    'boardTemplates.withStyleHint': ' — Hintergrund, Rahmen, Satzspiegel und Raster',
    'boardTemplates.withNotes': 'Sprechernotizen',
    'boardTemplates.notesNone': ' — keine hinterlegt',
    'boardTemplates.notesSome': ' — {noted} von {total} Frames haben eine',
    'boardTemplates.notesUnavailable': ' — nicht verfügbar',
    'boardTemplates.inSkeleton': '{frames} im Gerüst.',
    'boardTemplates.save': 'Boardvorlage sichern',
    'boardTemplates.composeTitle': 'Boardvorlage zusammenstellen',
    'boardTemplates.composePlaceholder': 'z. B. Wochenrunde',
    'boardTemplates.layout': 'Anordnung',
    'boardTemplates.frames': 'Frames',
    'boardTemplates.columns': 'Spalten',
    'boardTemplates.oneRow': 'Eine Reihe',
    'boardTemplates.format': 'Format',
    'boardTemplates.labels': 'Beschriftung',
    // --- Design ----------------------------------------------------------------
    'theme.title': 'Design des Boards',
    'theme.lead': 'Gilt für dieses Board und alle, die daran arbeiten. Die Hausfarben stehen danach in jedem Farbwähler oben.',
    'theme.background': 'Hintergrund',
    'theme.backgroundLabel': 'Untergrund',
    'theme.palette': 'Hausfarben',
    'theme.color': 'Farbe {number}',
    'theme.headings': 'Überschriften',
    'theme.body': 'Fließtext',
    'theme.reset': 'Standard von {org} übernehmen',
    'theme.resetTitle': 'Untergrund, Hausfarben und Schriften auf den Standard der Organisation setzen',
    'design.title': 'Design · {org}',
    'design.lead': 'Womit neue Boards dieser Organisation starten. Bestehende Boards bleiben, wie sie sind.',
    'design.previewBody': 'Fließtext, wie er auf neuen Boards erscheint.',
    'design.save': 'Als Standard sichern',
    'design.saving': 'Wird gesichert …',
    'design.saved': 'Gesichert',
    'design.saveFailed': 'Speichern fehlgeschlagen.',
    'design.adminOnly': 'Ändern kann das Standard-Design nur die Verwaltung.',
    'design.logo': 'Logo',
    'design.logoHint': 'Steht auf dem Wartebildschirm, den Gäste vor Beginn einer Präsentation sehen. SVG, PNG oder WebP, höchstens 512 KB — am besten freigestellt mit durchsichtigem Grund. Eine SVG bleibt in jeder Größe scharf.',
    'design.logoAlt': 'Logo von {org}',
    'design.noLogo': 'Kein Logo',
    'design.chooseLogo': 'Logo wählen',
    'design.replace': 'Ersetzen',
    'design.logoFailed': 'Logo konnte nicht gesetzt werden.',
    'design.logoRemoveFailed': 'Logo konnte nicht entfernt werden.',
    'design.fonts': 'Schriften',
    // --- Schriften -------------------------------------------------------------
    'fonts.builtIn': 'Eingebaut',
    'fonts.added': 'Hinzugefügt',
    'fonts.addGoogle': 'Schrift von Google Fonts hinzufügen',
    'fonts.googlePlaceholder': 'z. B. Inter, Playfair Display …',
    'fonts.fetch': 'Holen',
    'fonts.loading': 'Lädt …',
    'fonts.googleHint': 'Die Schrift wird einmalig geholt und danach von diesem Server ausgeliefert — im Vortrag ist sie damit auch ohne Internet da. Sie gehört dieser Organisation.',
    'fonts.uploadOwn': 'Eigene Schriftdatei hochladen',
    'fonts.uploadHint': 'WOFF2, OTF oder TTF, höchstens {limit}. OTF und TTF werden beim Hochladen nach WOFF2 gewandelt. Für Regulär und Fett je eine Datei hochladen — beide unter demselben Namen ergeben eine Schrift.',
    'fonts.namePlaceholder': 'Name der Schrift',
    'fonts.regular': 'Regulär',
    'fonts.bold': 'Fett',
    'fonts.upright': 'Aufrecht',
    'fonts.italic': 'Kursiv',
    'fonts.licenseConfirm': 'Die Lizenz dieser Schrift erlaubt die Einbettung auf einem Webserver (Webfont-Recht).',
    'fonts.upload': 'Hochladen',
    'fonts.fetchFailed': 'Schrift konnte nicht geladen werden.',
    'fonts.uploadFailed': 'Schrift konnte nicht hochgeladen werden.',
    'fonts.removeFailed': 'Entfernen fehlgeschlagen.',
    'fonts.fromProvider': 'vom Betreiber',
    'fonts.ownFile': 'eigene Datei',
    // --- Farbwähler ------------------------------------------------------------
    'color.pick': 'Farbe wählen',
    'color.boardColors': 'Board-Farben',
    'color.suggestions': 'Vorschläge',
    'color.none': 'Ohne Farbe',
    'color.custom': 'Eigene',
    // --- Neues Board -----------------------------------------------------------
    'newBoard.title': 'Neues Board',
    'newBoard.defaultTitle': 'Neues Board',
    'newBoard.failed': 'Board konnte nicht angelegt werden.',
    'newBoard.skeleton': 'Gerüst',
    'newBoard.empty': 'Leeres Board',
    'newBoard.emptyMeta': 'Ohne Frames',
    'newBoard.skeletonHint': 'Ein Gerüst legt leere Frames an — die Bühnen deines Vortrags. Inhalt kommt keiner mit.',
    'newBoard.titlePlaceholder': 'z. B. Kundenpräsentation Q3',
    'newBoard.titleHint': 'Ohne Angabe heißt es „Neues Board" — umbenennen geht jederzeit.',
    'newBoard.accent': 'Akzentfarbe',
    'newBoard.accentHint': 'Rahmen, Hervorhebungen und die erste Wahl im Farbwähler.',
    'newBoard.previewHeading': 'Kundenpräsentation Q3',
    'newBoard.previewBody': 'Fließtext, wie er auf dem Board erscheint.',
    'newBoard.create': 'Board anlegen',
    'newBoard.creating': 'Wird angelegt …',
    // --- Verlauf ---------------------------------------------------------------
    'history.title': 'Verlauf des Boards',
    'history.loadListFailed': 'Der Verlauf konnte nicht geladen werden.',
    'history.loadFailed': 'Dieser Stand konnte nicht geladen werden.',
    'history.loadingList': 'Verlauf wird geladen …',
    'history.loadingState': 'Stand wird geladen …',
    'history.empty': 'Für dieses Board gibt es noch keine gesicherten Stände. Der erste entsteht, sobald du etwas darauf ablegst — danach wird viertelstündlich einer festgehalten.',
    'history.today': 'Heute, {time} Uhr',
    'history.yesterday': 'Gestern, {time} Uhr',
    'history.on': '{day}, {time} Uhr',
    'history.counts': '{elements} Elemente, {frames} Frames',
    'history.beforeRestore': 'Vor dem Wiederherstellen',
    'history.confirm': 'Das Board wird auf den Stand vom {moment} zurückgesetzt — bei allen Beteiligten zugleich. Der jetzige Stand wird vorher gesichert.',
    'history.restore': 'Diesen Stand wiederherstellen',
    'history.restoreConfirm': 'Ja, zurückholen',
    'history.restoring': 'Wird zurückgeholt …',
    'history.restoreFailed': 'Der Stand konnte nicht zurückgeholt werden.',
    // --- Adresse einbetten -----------------------------------------------------
    'url.addTitle': 'Website einbetten',
    'url.editTitle': 'Adresse ändern',
    'url.address': 'Adresse',
    'url.incomplete': 'Bitte eine vollständige Adresse angeben.',
    'url.httpsOnly': 'Nur https-Adressen lassen sich einbetten.',
    'url.insert': 'Einfügen',
    'url.confirm': 'Übernehmen',
    'url.placeholder': 'https://beispiel.de',
    'url.embedHint': 'Manche Seiten verbieten das Einbetten technisch. Præsto zeigt dann einen Hinweis mit Direktlink statt eines leeren Rahmens.',
    // --- Teilnehmerliste -------------------------------------------------------
    'participants.title': 'Teilnehmende',
    'participants.one': '{count} Teilnehmer',
    'participants.many': '{count} Teilnehmende',
    'participants.inBoard': '{people} im Board',
    'participants.you': '(du)',
    'participants.presenting': 'präsentiert',
    'participants.watching': 'sieht zu',
    'participants.editing': 'bearbeitet',
    'participants.following': 'folgt',
    'participants.lookingAround': 'sieht sich um',
    // --- Frame- und Ebenenliste ------------------------------------------------
    'frames.empty': 'Ein Frame hält den aktuellen Bildausschnitt fest. Die Reihenfolge hier ist die Reihenfolge der Präsentation.',
    'frames.itemTitle': 'Klick zoomt auf den Frame · Doppelklick benennt ihn um',
    'frames.note': 'Sprechernotiz',
    'frames.noteTitle': 'Sprechernotiz — nur für dich, nie für Gäste',
    'frames.notePlaceholder': 'Was du zu diesem Frame sagen willst. Sieht nur, wer das Board bearbeiten darf.',
    'frames.drag': 'Ziehen sortiert um · Alt+↑/↓ tut dasselbe ohne Maus',
    'frames.delete': 'Frame löschen',
    'layers.text': 'Text',
    'layers.media': 'Medium',
    'layers.forward': 'Eine Ebene nach vorn',
    'layers.backward': 'Eine Ebene nach hinten',
    'layers.noFrame': 'Ohne Frame',
    'layers.empty': 'Noch nichts auf dem Board. Über „Medien", „Website" oder „Text" oben fügst du etwas hinzu.',
};
//# sourceMappingURL=dialogs.js.map